var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHexLogoinline = function SvgHexLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 280,
    rx: 20,
    fill: "#01011B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.258 105v23.29h-5.903V105H55v70h23.355v-34.903h5.903V175h23.355v-70H84.258ZM142.776 105h-29.258v70h52.612v-29.193h-23.354v17.387h-5.903v-23.113h29.258V105h-23.355Zm-5.903 23.275v-11.468h5.903v11.467l-5.903.001ZM201.356 105v23.112h-5.903V105h-23.355v17.501l11.677 11.677-11.677 11.676V175h23.355V139.919h5.903V175h23.355V145.854l-11.677-11.676 11.677-11.677V105h-23.355Z",
    fill: "#F5C0C0"
  })));
};
export default SvgHexLogoinline;